if (!window.$eventCalls) {
	let ec = require('./eventCalls');
	window.$eventCalls = new ec.VioletEventCalls();
}

export class VioletEventsList {
	
	constructor() {
		this._lastEventId = parseInt($('#last-event-id').data('id'));
		this._pollIdEventUpdatedAt = null;
		
		this.initApp();
	}

	//-------------------------------------------------------------------------


	/**
	 *
	 */
	pollId() {
		let app = this;
		$.ajax({
			type: "post",
			url: route('events.pollLastId'),
			data: {
				'current_id': app._lastEventId,
				'current_time': app._pollIdEventUpdatedAt ? app._pollIdEventUpdatedAt : new Date().toLocaleString(),
			},
			timeout: 20000,
			success: function (r) {
				app._pollIdEventUpdatedAt = null;
				
				if (r && r.id && r.action && r.message) {
					if (window.$sbAdminDatatables) {
						if (r.action === 'add' && (parseInt(r.id) !== app._lastEventId)) {
							//Reload table
							app.reloadTable(r.action);
							
							//Update current ID
							app._lastEventId = parseInt(r.id);
						
							//Send notification
							app.pollIdNotification(parseInt(r.id), r.message)
						}

						if (r.action === 'change') {
							app._pollIdEventUpdatedAt = r.updatedAt;

							//Reload table
							app.reloadTable(r.action);
						
							//Send notification
							app.pollIdNotification(parseInt(r.id), r.message)
						}
					}
				}
				//Prepare next query
				app.scheduleAutomaticReload(100);
			},
			error: function (r) {
				app._pollIdEventUpdatedAt = null;
				
				app.scheduleAutomaticReload(1000);
				console.error(r);
			},
		});
	}

	/**
	 * @param {string} action - add | change
	 */
	reloadTable(action) {
		let table = window.$sbAdminDatatables.getTable('eventsListTable');
		table.ajax.reload();
		window.setTimeout(() => {
			switch (action) {
				case 'add':
					$('#eventsListTable tr.newly-added').removeClass('newly-added');
					break;
				case 'change':
					$('#eventsListTable tr.changed').removeClass('changed');
					break;
			}
		}, 30000);
	}

	/**
	 * @param {number} id - event ID
	 * @param {string} message 
	 */
	pollIdNotification(id, message) {
		if (window.Notification.permission === "granted") {
			let img = $('base').attr('href') + "/assets/main_logo.png";
			const n = new Notification("Violet", { body: message, icon: img });
			n.onclick = () => {
				window.open(route('events.show', { event: id }), '_blank')
			}
			window.setTimeout(() => { n.close(); }, 10000);
		}
	}

	//-------------------------------------------------------------------------

	/**
	 *
	 */
	initApp() {
		var app = this;
		
		app.initButtons();
		app.scheduleAutomaticReload(100);
	}
	
	/**
	 * 
	 */
	initButtons() {
		var app = this,
			$document = $(document),
			eventStates = window.$Common.events.states;
		
		//TODO prehrani hovoru
		/*$document.on('click', '#add-stagecoach', function (e) {
			e.preventDefault();
			app.addVehicle($(this));
		});*/
	}

	/**
	 * 
	 * @param timeout
	 */
	scheduleAutomaticReload(timeout) {
		let app = this;
		window.setTimeout(function() {
			app.pollId();
		}, timeout);
	}
}
